import { Dispatch } from 'redux'

import { removeIdToken, removeSessionToken } from '~/shared/lib/auth'
import { GET_ME } from './actionTypes'
import { queueNotification } from '~/shared/notifications/actions'
import { providersUserMe, ProvidersUserMeRetrieveResponse } from '@fireflyhealth/api'
import { logger } from '~/shared/lib/logger'

const getMeRequestSuccess = (data: ProvidersUserMeRetrieveResponse) => ({
  // This type cast looks ridiculous, but prevents the literal from getting
  // widened to string.
  type: GET_ME as typeof GET_ME,
  me: data,
})

export type MeAction = ReturnType<typeof getMeRequestSuccess>

export function getMe() {
  return async (dispatch: Dispatch) => {
    try {
      const { data } = await providersUserMe.retrieve({ provider_id: 'me' })
      if (data.provider_fields === null) {
        // Remove token from storage
        removeSessionToken()
        removeIdToken()
        throw new Error('User is a patient')
      }
      return dispatch(getMeRequestSuccess(data))
    } catch (e) {
      logger.error('[Session] fetch me', e)
      dispatch(queueNotification({ variant: 'error', message: 'Error fetching "me"' }))
      throw e
    }
  }
}
